

import {Component, Vue} from "vue-property-decorator"
import {IAppletBanner} from "@/apis/applet/banner/types"
import config from "@/config";
import Qrcode from "qrcodejs2"
import type {ICrudOption} from "@/types/m-ui-crud"
import {IPage} from "@/apis/page";
import {
  fruitTreeSourceCreateApi,
  fruitTreeSourceDetailApi,
  fruitTreeSourceModifyApi,
  fruitTreeSourceQueryApi,
  fruitTreeSourceRemoveApi,
  getFruitTreeListApi,
  getPlantationListApi
} from "@/apis/linye";

@Component({})
export default class SourceCode extends Vue {
  config = config
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: any[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IPage = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<any> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    searchBox: true,
    dialogWidth: '70%',
    labelWidth: '150px',
    column: [
      {
        label: "ID",
        type: "index",
        prop: "id",
        align: "center",
        width: 50,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园名称",
        prop: "plantationName",
        align: "center",
        search: true,
        width: 150,
        addHide: true,
        editHide: true
      },
      {
        label: "品种名称",
        prop: "fruitTreeName",
        align: "center",
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园",
        prop: "plantationId",
        search: false,
        hide: true,
        rules: [
          {required: true, message: "请选择种植园", trigger: "blur"}
        ],
        addSlot: true,
        editSlot: true
      },
      {
        label: "品种",
        prop: "fruitTreeId",
        search: false,
        hide: true,
        rules: [
          {required: true, message: "请选择品种", trigger: "blur"}
        ],
        addSlot: true,
        editSlot: true
      },
      {
        label: "详情",
        prop: "dtl",
        hide: true,
        span: 24,
        addSlot: true,
        editSlot: true,
        rules: [
          {required: true, message: "详情不能为空", trigger: "blur"},
          {
            validator: (rule: any, value: string, callback: Function) => {
              if (value.length > 800) {
                return callback(new Error('商品详情最多800个字符'))
              }
              callback()
            }
          }
        ]
      },
      {
        label: "创建人",
        prop: "handleBy",
        align: "center",
        width: '250px',
        addHide: true,
        editHide: true
      },
      {
        label: "创建时间",
        prop: "addTime",
        align: "center",
        width: '150px',
        addHide: true,
        editHide: true,
      },

    ]
  }
  plantationList: any [] = []
  fruitTreeList: any [] = []

  getList() {
    this.tableLoading = true
    fruitTreeSourceQueryApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  openAdd() {
    getPlantationListApi({}).then(res => {
      this.plantationList = res
    })
    // @ts-ignore
    this.$refs.crudRef.rowAdd()
  }

  openEdit(row: any, index: number) {
    fruitTreeSourceDetailApi(row.id).then(e => {
      if (e) {
        this.plantationChange(row.plantationId)
        getPlantationListApi({}).then(res => {
          this.plantationList = res
        })
        // @ts-ignore
        this.$refs.crudRef.rowEdit(e, index)
      }
    })
  }

  plantationChange(e: any) {
    this.fruitTreeList = []
    this.modelForm.fruitTreeId = ''
    getFruitTreeListApi({plantationId: e}).then(res => {
      this.fruitTreeList = res
    })
  }

  rowSave(form: IAppletBanner, done: Function, loading: Function) {
    fruitTreeSourceCreateApi(form).then(e => {
      if (e) {
        this.getList()
        this.$message.success("操作成功!")
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  rowEdit(form: any, done: Function, loading: Function) {
    fruitTreeSourceModifyApi(form).then(e => {
      if (e) {
        this.$message.success('操作成功!')
        this.getList()
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  submitRemove(form: any, i: any) {
    fruitTreeSourceRemoveApi(form.id).then(e => {
      if (e) {
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
        this.getList();
      }
    })
  }

  // 查看弹窗
  viewDialog = false

  openView(row: any) {
    this.viewDialog = true
    setTimeout(() => {
      this.$nextTick(() => {
        const dom = document.querySelector(`#viewcode`)
        dom!.innerHTML = '';
        new Qrcode(dom, {
          text: row.codeUrl,
          width: 120,
          height: 120
        })
      })
    }, 0)
  }

  created() {
    this.getList()
  }
}
